import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { listSenders } from 'services/SenderService';
import { getLiteral } from 'utils/getLiteral';
import { errorToast } from 'utils/toast';
import { canManageMarketingCampaigns } from '../utils/marketingCampaignPermissions';

export default function useCheckInitialSetup() {
    const navigate = useNavigate();
    const canManage = useSelector(canManageMarketingCampaigns);
    const [senders, setSenders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoading(true);
        setLoaded(false);
        listSenders()
            .then((items) => {
                setSenders(Array.isArray(items) ? items : []);
                setLoaded(true);
            })
            .catch(() => {
                errorToast({ text: getLiteral('error_generalerror') });
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const hasMinimumSenders = useMemo(() => {
        return senders.length > 0;
    }, [senders]);

    useEffect(() => {
        if (loaded && canManage && !hasMinimumSenders) {
            navigate('/campaigns/marketing/initial-setup', { replace: true });
        }
    }, [canManage, loaded, hasMinimumSenders, navigate]);

    const isLoading = useMemo(() => {
        return loading && !loaded;
    }, [loading, loaded]);

    const showReadOnlyInitialEmpty = useMemo(() => {
        return loaded && !canManage && !hasMinimumSenders;
    }, [canManage, hasMinimumSenders, loaded]);

    return {
        hasMinimumSenders,
        isLoading,
        loaded,
        showReadOnlyInitialEmpty,
    };
}
